import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { SendCartableFormViewModel } from "../sendCartableForm/sendCartableForm-viewModel";
import  { SendFormView } from "./sendForm-view"
import { PrintExitFormAction } from "../sendPackageDetail/sendPackageDetail-viewModel";
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";

export class SendFormViewModel extends ViewModel implements IPopup {
    constructor(parentViewModel: SendCartableFormViewModel) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.sendFormItems = ObservableArray.create<SendFormItem>();
    }
    GetDefaultView(): View <ViewModel> {
        return new SendFormView();
    }
    public getTypeId(): string {
        return "VM-1C48A80F-01A2-43EC-818F-74B95D9ADEB9"
    }
    private _typedParent : SendCartableFormViewModel;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set sendPackageId(v: string) { this._sendPackageId = v; } public get sendPackageId(): string { return this._sendPackageId;} private _sendPackageId: string;
    public set sendFormItems(v: ObservableArray<SendFormItem>) { this._sendPackageProducts = v; } public get sendFormItems(): ObservableArray<SendFormItem> { return this._sendPackageProducts; } private _sendPackageProducts: ObservableArray<SendFormItem>;
    public set driverId(v: string) { this._driverId = v; } public get driverId(): string { return this._driverId;} private _driverId: string;
    public set driverName(v: string) { this._driverName = v; } public get driverName(): string { return this._driverName; } private _driverName: string;
    public set driverPhone(v: string) { this._driverPhone = v; } public get driverPhone(): string { return this._driverPhone;} private _driverPhone: string;
    public set carNumber(v: string) { this._carNumber = v; } public get carNumber(): string { return this._carNumber;} private _carNumber: string;
    public set carType(v: string) { this._carType = v; } public get carType(): string { return this._carType;} private _carType: string;
    public set exitFormNumber(v: string) { this._exitFormNumber = v; } public get exitFormNumber(): string { return this._exitFormNumber;} private _exitFormNumber: string;
    public set driverSelector(v: DriverSelectorViewModel) { this._driverSelector = v; } public get driverSelector(): DriverSelectorViewModel { return this._driverSelector;} private _driverSelector: DriverSelectorViewModel;
    public set canSend(v: boolean) { this._canSend = v; } public get canSend(): boolean { return this._canSend;} private _canSend: boolean;
    
    async loadById(sendPackageId: string) {
        let result = await ServerConnection.callServer('Complex/WarehouseServices/GetSendFormDetail', {
            SendPackageId: sendPackageId
        });
        this.sendPackageId = sendPackageId;
        this.sendFormItems.update(...result.SendItems.map((q, i) => {
            let r = new SendFormItem(this);
            r.rowNumber = i + 1;
            r.measuredProductId = q.MeasuredProductId;
            r.productName = q.ProductName;
            r.productCode = q.ProductCode;
            r.productCarModel = q.ProductCarModel;
            r.productIndex = q.ProductIndex;
            r.amount = q.Amount;
            r.productUnit = q.ProductUnit;
            r.stockBalance = q.StockBalance;
            r.availableBalance = q.AccessibleBalance;
            r.marginAmount = q.MarginBalance;
            r.invoiceAmount = q.InvoiceBalance;
            r.requestAmount = q.RequestBalance;
            r.sendableAmount = q.SendableBalance;
            r.orderComment = q.OrderComment;
            r.counted = Math.min(q.SendableBalance, r.stockBalance);

            r.isCountCorrect = r.counted == r.amount;
            return r;
        }));
        this.canSend = true;
        this.driverSelector = new DriverSelectorViewModel(this);
        this.driverSelector.onSelectionChanged = x=> {
            this.driverId = x?.id;
            this.driverName = x?.title;
            this.carNumber = x?.carNumber;
            this.carType = x?.carType;
            this.driverPhone = x?.phone;
        };
    }

    verifySendForm():string[]{
        let result :string[] =[];
        if(!this.sendFormItems.every(x=> {
            return x.isCountCorrect || !stringIsNullOrEmpty(x.orderComment);
        })){
            result.push('برای کالاهایی که شمارششان صحیح نیست توضیحات بنویسید.')
        }
        if(!this.sendFormItems.every(x=> {
            return x.invoiceAmount <= x.counted;
        })){
            result.push('باید همه کالاهای فاکتورها را بفرستید.')
        }
        if(!this.sendFormItems.every(x=> {
            return x.sendableAmount >= x.counted;
        })){
            result.push('تعداد ارسالی بیشتر از درخواست هاست.')
        }
        if(!this.sendFormItems.every(x=> {
            return x.counted - x.invoiceAmount <= (x.availableBalance + x.marginAmount);
        })){
            result.push('تعداد درخواستی در دسترس نیست.')
        }
        if (stringIsNullOrEmpty(this.driverId)) {
            result.push('راننده مشخص نشده است.')
        }
        if (stringIsNullOrEmpty(this.exitFormNumber)) {
            result.push('شماره برگه خروج مشخص نشده است.')
        }
        return result;
    }

    verifyCreateDriver():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.driverPhone)){
            result.push('تلفن را وارد کنید.')
        }
        if(stringIsNullOrEmpty(this.driverName)){
            result.push('نام را وارد کنید.')
        }
        if(stringIsNullOrEmpty(this.carNumber)){
            result.push('پلاک ماشین را وارد کنید.')
        }
        if(stringIsNullOrEmpty(this.carType)){
            result.push('نوع ماشین را وارد کنید.')
        }
        return result;
    }

    async send(){
        try {
            let verificationResult = this.verifySendForm();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ارسال');
                return;
            }
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/WarehouseServices/SendOnePackage',{
                OrderAmounts:this.sendFormItems.map(q => {return { 
                    OrderAmount: q.counted,
                    MeasuredProductId: q.measuredProductId,
                    OrderComment: q.orderComment
                }}),
                SendPackageId:this.sendPackageId,
                ExitFormNumber:this.exitFormNumber,
                DriverId:this.driverId,
            });
            await this.messageBoxConfirmSuccess('ارسال با موفقیت انجام شد.','عملیات موفق');
            this.close_popup("done");
            new PrintExitFormAction().Print(this,this.sendPackageId);
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async createOrUpdateDriver(){
        try {
            let verificationResult = this.verifyCreateDriver();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت راننده');
                return;
            }
            this.isLoading = true;
            if (this.driverId) {            
                await ServerConnection.callServer('/Complex/WarehouseServices/UpdateDriver',{
                    DriverId:this.driverId,
                    DriverName:this.driverName,
                    PhoneNumber:this.driverPhone,
                    CarType:this.carType,
                    CarNumber:this.carNumber
                });
                await this.messageBoxConfirmSuccess('راننده با موفقیت بروز شد.','عملیات موفق');
            } else {
                let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateDriver',{
                    SendPackageId:this.sendPackageId,
                    DriverName:this.driverName,
                    PhoneNumber:this.driverPhone,
                    CarType:this.carType,
                    CarNumber:this.carNumber
                });
                this.driverId = result.DriverId;
                await this.messageBoxConfirmSuccess('راننده با موفقیت ثبت شد.','عملیات موفق');
            }

        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    close_popup(resultCode: string = null) {
        this._typedParent.refresh();
        this.closePopup(resultCode);
    }

    closePopup(resultCode: string = null) {
        this._typedParent.refresh();
    }
}

export class SendFormItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: SendFormViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: SendFormViewModel;

    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set productUnit(v: string) { this._productUnit = v; } public get productUnit(): string { return this._productUnit;} private _productUnit: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId; } private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set productIndex(v: string) { this._productIndex = v; } public get productIndex(): string { return this._productIndex;} private _productIndex: string;
    public set stockBalance(v: number) { this._stockBalance = v; } public get stockBalance(): number { return this._stockBalance;} private _stockBalance: number;
    public set availableBalance(v: number) { this._availableBalance = v; } public get availableBalance(): number { return this._availableBalance;} private _availableBalance: number;
    public set sendableAmount(v: number) { this._sendableAmount = v; } public get sendableAmount(): number { return this._sendableAmount;} private _sendableAmount: number;
    public set marginAmount(v: number) { this._marginAmount = v; } public get marginAmount(): number { return this._marginAmount;} private _marginAmount: number;
    public set invoiceAmount(v: number) { this._invoiceAmount = v; } public get invoiceAmount(): number { return this._invoiceAmount;} private _invoiceAmount: number;
    public set requestAmount(v: number) { this._requestAmount = v; } public get requestAmount(): number { return this._requestAmount;} private _requestAmount: number;
    public set counted(v: number) { 
        this._counted = getAsNumber(v,true); 
        this.isCountCorrect = this._counted == this.amount;
    } public get counted(): number { return this._counted;} private _counted: number;
    public set orderComment(v: string) { this._orderComment = v; } public get orderComment(): string { return this._orderComment;} private _orderComment: string;
    public set isCountCorrect(v: boolean) { this._isCountCorrect = v; } public get isCountCorrect(): boolean { return this._isCountCorrect;} private _isCountCorrect: boolean;
    
    async onePlus(){
        this.counted++;
    }

}

export class DriverSelectorViewModel extends SearchableSelectorBaseViewModel<DriverForSelector>{
    
    constructor(parentViewModel: ViewModel, customerId?:string) {
        super(parentViewModel);
        this.customerId = customerId;
        this.cachedData = [];
        this.loadCachedData()
        // this.refresh();
    }

    public set customerId(v: string) { this._customerId = v; } public get customerId(): string { return this._customerId;} private _customerId: string;
    
    protected loadData(searchedText: string): Promise<DriverForSelector[]> {
        let result = this.cachedData.filter(x=>{
            if(x.title.includes(searchedText))
                return true;
            if(x.phone.includes(searchedText))
                return true;
            return false;
        })
        return Promise.resolve<DriverForSelector[]>(result);
    }
    protected loadById(id: string): Promise<DriverForSelector> {
        let result = this.cachedData.filter(x=>x.id==id).at(0);
        return Promise.resolve<DriverForSelector>(result);
    }

    private cachedData : DriverForSelector[];

    protected async loadCachedData(): Promise<any> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllDrivers',{});
        this.cachedData = result.Drivers.map(q=>{
            let result = new DriverForSelector(this);
            result.id = q.DriverId;
            result.title = q.DriverName;
            result.phone = q.PhoneNumber;
            result.carNumber = q.CarNumber;
            result.carType = q.CarType;
            return result;
        });
    }

    // protected loadById(id: string): Promise<DriverForSelector> {
    //     throw new Error("Method not implemented.");
    // }
    
}

class DriverForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set phone(v: string) { this._phone = v; } public get phone(): string { return this._phone;} private _phone: string;
    public set carNumber(v: string) { this._carNumber = v; } public get carNumber(): string { return this._carNumber;} private _carNumber: string;
    public set carType(v: string) { this._carType = v; } public get carType(): string { return this._carType;} private _carType: string;
    
}

